// Son variable que se emplean de forma global en dinamcios

const state = () => ({
  aInfoProceso : [],        // Informacion del proceso en curso
  oVariablesGlobales: {}    // objetos con las variables globales se almacena bajo el nombre del proeceso 
})

const getters = {
  getaInfoProceso: ( state ) => {
    return state.aInfoProceso;
  },
  getLlaveProceso: ( state ) => {
    return state.aInfoProceso?.Llave
  },
  getEstadoInicial: ( state ) => {
    return state.aInfoProceso?.EstadoInicial
  },
  getPrimeraTransition: ( state ) => {
    return Object.values(state.aInfoProceso?.Transitions)[0]
  },
  // entrega el bloque completo
  getoVariablesGlobales: ( state ) => {
    return state.oVariablesGlobales
  },
  getoVariablesGlobales_Filter : ( state ) => (nIdProceso) => {
    return state.oVariablesGlobales[nIdProceso] ||  {};
  },
  getFiltrosGlobales: ( state ) => {
    return state.aInfoProceso.filtrosGlobales
  }
} 

const mutations = {
  SALVAR_aINFOPROCESO : ( state, value ) => {
    state.aInfoProceso = value
  },
  SALVAR_oVariablesGlobales : ( state, {nIdProceso, variable, valor} ) => {
    const procesoVars = state.oVariablesGlobales[nIdProceso] ? { ...state.oVariablesGlobales[nIdProceso] } : {}

    procesoVars[`${variable}`] = valor

    state.oVariablesGlobales = { ...state.oVariablesGlobales, [nIdProceso]: procesoVars }
  },
  CLEAR_oVariablesGlobales: (state )=> {
    state.oVariablesGlobales = {}
  },
  CLEAR_oVariablesGlobales_IDPRoceso : ( state, {nIdProceso}) =>{
    console.log('state.oVariablesGlobales[nIdProceso]', state.oVariablesGlobales[nIdProceso])
     if(state.oVariablesGlobales[nIdProceso]) delete state.oVariablesGlobales[nIdProceso]
  }


}

const actions = {
  pushaInfoProceso( {commit}, value ) {
    commit( "SALVAR_aINFOPROCESO", value);
  },
  push_oVariablesGlobales ( {commit}, value ) {
    commit("SALVAR_oVariablesGlobales", value)
  }, 
  clear_oVariablesGlobales ( {commit} ) {
    commit("CLEAR_oVariablesGlobales")
  }, 
  clear_oVariablesGlobales_Proceso ( {commit}, value ) {
    commit("CLEAR_oVariablesGlobales_IDPRoceso", value)
  }, 

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}